var $bdedb98bd3140b35$exports = {};
$bdedb98bd3140b35$exports = {
    "clear": `T\xf6rl\xe9s`,
    "invalid": `(\xe9rv\xe9nytelen)`,
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "noResults": `Nincsenek tal\xe1latok`,
    "valid": `(\xe9rv\xe9nyes)`
};


export {$bdedb98bd3140b35$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
